import React from 'react';
import { motion } from 'framer-motion';
import { Megaphone, Target, Calendar, UserPlus, CheckCircle2 } from 'lucide-react';
export function Services() {
  const services = [{
    icon: <Megaphone className="w-8 h-8" data-id="element-237" />,
    title: 'Digital Marketing & Brand Development',
    items: ['Content strategy', 'Social media management', 'Email campaigns', 'Brand development'],
    desc: 'Elevate your market presence with data-driven creative strategies.'
  }, {
    icon: <Target className="w-8 h-8" data-id="element-238" />,
    title: 'Cold Outreach & Lead Qualification',
    items: ['Phone outreach', 'Email prospecting', 'Prospect research', 'Lead qualification'],
    desc: 'Strategic prospecting that fills your pipeline with high-intent leads.'
  }, {
    icon: <Calendar className="w-8 h-8" data-id="element-239" />,
    title: 'Lead Generation & Appointment Setting',
    items: ['Inbound management', 'Appointment setting', 'Funnel optimization', 'Industry lead systems'],
    desc: 'Turn interest into action with seamless appointment setting workflows.'
  }, {
    icon: <UserPlus className="w-8 h-8" data-id="element-240" />,
    title: 'HRaaS & Staffing Solutions',
    items: ['On-demand staffing', 'Customer service', 'Admin support', 'Recruitment support'],
    desc: 'Flexible staffing models that adapt to your business velocity.'
  }];
  return <section id="services" className="py-12 lg:py-24" data-id="element-241">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-242">
        <div className="text-center max-w-3xl mx-auto mb-10 lg:mb-20" data-id="element-243">
          <h2 className="text-brand-accent font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4" data-id="element-244">
            Our Expertise
          </h2>
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white mb-4 sm:mb-6" data-id="element-245">
            Comprehensive Business Support
          </h3>
          <p className="text-base sm:text-lg text-slate-400" data-id="element-246">
            Tailored solutions designed to remove operational bottlenecks and
            accelerate your growth trajectory.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-247">
          {services.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="group p-6 sm:p-8 rounded-[2rem] sm:rounded-3xl bg-white/5 border border-white/10 hover:border-brand-accent/50 transition-all relative overflow-hidden" data-id="element-248">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-249">
                {s.icon}
              </div>
              <div className="text-brand-accent mb-6 group-hover:scale-110 transition-transform origin-left" data-id="element-250">
                {s.icon}
              </div>
              <h4 className="text-xl font-bold text-white mb-4 leading-tight" data-id="element-251">
                {s.title}
              </h4>
              <p className="text-sm text-slate-400 mb-6 leading-relaxed" data-id="element-252">
                {s.desc}
              </p>

              <ul className="space-y-3" data-id="element-253">
                {s.items.map((item, idx) => <li key={idx} className="flex items-center gap-2 text-sm text-slate-300" data-id="element-254">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent/60" data-id="element-255" />
                    {item}
                  </li>)}
              </ul>

              <div className="mt-8 pt-6 border-t border-white/10" data-id="element-256">
                <button className="text-brand-accent text-sm font-bold flex items-center gap-2 group-hover:gap-3 transition-all" data-id="element-257">
                  Learn More <span className="text-lg" data-id="element-258">→</span>
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}